import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 300px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  .ant-select {
    width: 100%;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 32px;
  border: 1px solid ${({ theme }) => theme.colors.black9};
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 100px;
  padding: 4px 16px;
  cursor: pointer;
  font-weight: 600;

  &:hover {
    border-color: ${({ theme }) => theme.colors.green7};
    color: ${({ theme }) => theme.colors.green7};
  }
`;

export const ClearFiltersWrapper = styled.div`
  font-weight: 600;
  cursor: pointer;
  padding: 4px 8px;
  margin-top: 8px;
`;

export const SwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${({ theme }) => theme.colors.green6};
    border-color: ${({ theme }) => theme.colors.green6};
    &:hover {
      background-color: ${({ theme }) => theme.colors.green6};
      border-color: ${({ theme }) => theme.colors.green6};
    }
  }
  .ant-checkbox-inner {
    border-color: ${({ theme }) => theme.colors.black4};
  }
  &:hover {
    .ant-checkbox-inner {
      border-color: ${({ theme }) => theme.colors.green6};
    }
  }

  .ant-checkbox-checked .ant-checkbox-inner::after {
    border-color: white;
  }

  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: ${({ theme }) => theme.colors.green6} !important;
  }

  &:hover .ant-checkbox-inner {
    border-color: ${({ theme }) => theme.colors.green6};
  }
`;
export const FiltersWrapper = styled.div`
  display: flex;
  align-items: start;
  gap: 12px;
  flex-direction: column;

  @media (min-width: ${({ theme }) => theme.mediaQueries.xs}) {
    flex-direction: row;
    align-items: center;
  }
`;

export const SelectorWrapper = styled.div`
  .ant-select {
    width: 100%;
    min-width: 256px;
  }
`;
